module.exports = "/_next/static/images/qr-3eb057655da0fb5ed574fadd951d1896.png";